// extracted by mini-css-extract-plugin
module.exports = {"container":"_3VyIATLkGjWvBwD8FV-srK","groupsList":"_1KGVuKhk82Am0F1tsp3cYK"};